// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FileUpload Component Styles */

:root {
  --scl--cms-components-fileUpload-bg: #FFFFFF;
  --scl--cms-components-fileUpload-border-color: #E5E5E7;
  --scl--cms-components-fileUpload-border-radius: 10px;
  --scl--cms-components-fileUpload-drag-bg: #F5F8FF;
  --scl--cms-components-fileUpload-drag-border-color: var(--primarypalette-blue);

  --scl--cms-components-fileUpload-icon-btn-size: 36px;
  --scl--cms-components-fileUpload-icon-btn-shadow: 0px 0px 0px 3px #EFF1F3;
  --scl--cms-components-fileUpload-icon-color: #323539;

  --scl--cms-components-fileUpload-text-color: #323539;
  --scl--cms-components-fileUpload-link-color: var(--primarypalette-blue);
  --scl--cms-components-fileUpload-support-color: #858C95;
}

/* Container */
.scl--cms-components-fileUpload-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 16px;
  width: 100%;
  max-width: 429px;
  min-height: 128px;
  background: var(--scl--cms-components-fileUpload-bg);
  border: 1px dashed var(--scl--cms-components-fileUpload-border-color);
  border-radius: var(--scl--cms-components-fileUpload-border-radius);
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  position: relative;
  outline: none;
}

.scl--cms-components-fileUpload-container:hover {
  border-color: #C0C0C5;
  background: #FAFAFA;
}

.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging {
  background: var(--scl--cms-components-fileUpload-drag-bg);
  border-color: var(--scl--cms-components-fileUpload-drag-border-color);
  box-shadow: 0px 0px 0px 3px rgba(35, 136, 255, 0.15);
}

.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

/* Hidden native file input */
.scl--cms-components-fileUpload-input {
  display: none;
}

/* Icon Button */
.scl--cms-components-fileUpload-iconBtn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  width: var(--scl--cms-components-fileUpload-icon-btn-size);
  height: var(--scl--cms-components-fileUpload-icon-btn-size);
  background: var(--scl--cms-components-fileUpload-bg);
  border: 1px solid var(--scl--cms-components-fileUpload-border-color);
  box-shadow: var(--scl--cms-components-fileUpload-icon-btn-shadow);
  border-radius: 128px;
  flex: none;
  flex-shrink: 0;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.scl--cms-components-fileUpload-container:hover .scl--cms-components-fileUpload-iconBtn,
.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging .scl--cms-components-fileUpload-iconBtn {
  border-color: var(--primarypalette-blue);
  box-shadow: 0px 0px 0px 3px rgba(35, 136, 255, 0.15);
}

/* Upload SVG icon */
.scl--cms-components-fileUpload-icon {
  width: 20px;
  height: 20px;
  flex: none;
}

.scl--cms-components-fileUpload-icon path,
.scl--cms-components-fileUpload-icon line,
.scl--cms-components-fileUpload-icon polyline {
  stroke: var(--scl--cms-components-fileUpload-icon-color);
  stroke-width: 1.67px;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  transition: stroke 0.2s ease;
}

.scl--cms-components-fileUpload-container:hover .scl--cms-components-fileUpload-icon path,
.scl--cms-components-fileUpload-container:hover .scl--cms-components-fileUpload-icon line,
.scl--cms-components-fileUpload-container:hover .scl--cms-components-fileUpload-icon polyline,
.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging .scl--cms-components-fileUpload-icon path,
.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging .scl--cms-components-fileUpload-icon line,
.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging .scl--cms-components-fileUpload-icon polyline {
  stroke: var(--primarypalette-blue);
}

/* Text block */
.scl--cms-components-fileUpload-text {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 6px;
  width: 100%;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
}

/* Header row */
.scl--cms-components-fileUpload-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 4px;
  width: 100%;
  flex: none;
  align-self: stretch;
  flex-wrap: wrap;
}

.scl--cms-components-fileUpload-headerText {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: var(--scl--cms-components-fileUpload-text-color);
}

.scl--cms-components-fileUpload-link {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: var(--scl--cms-components-fileUpload-link-color);
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.15s ease;
}

.scl--cms-components-fileUpload-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}

/* Support text */
.scl--cms-components-fileUpload-support {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 4px;
  width: 100%;
  flex: none;
  align-self: stretch;
  flex-grow: 1;
}

.scl--cms-components-fileUpload-supportText {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: var(--scl--cms-components-fileUpload-support-color);
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/card-fs-cp/upload-card-op/css/fileUpload.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,4CAA4C;EAC5C,sDAAsD;EACtD,oDAAoD;EACpD,iDAAiD;EACjD,8EAA8E;;EAE9E,oDAAoD;EACpD,yEAAyE;EACzE,oDAAoD;;EAEpD,oDAAoD;EACpD,uEAAuE;EACvE,uDAAuD;AACzD;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oDAAoD;EACpD,qEAAqE;EACrE,kEAAkE;EAClE,eAAe;EACf,8EAA8E;EAC9E,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yDAAyD;EACzD,qEAAqE;EACrE,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,0DAA0D;EAC1D,2DAA2D;EAC3D,oDAAoD;EACpD,oEAAoE;EACpE,iEAAiE;EACjE,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,wDAAwD;AAC1D;;AAEA;;EAEE,wCAAwC;EACxC,oDAAoD;AACtD;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;;EAGE,wDAAwD;EACxD,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uDAAuD;EACvD,eAAe;EACf,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0DAA0D;EAC1D,WAAW;AACb","sourcesContent":["/* FileUpload Component Styles */\n\n:root {\n  --scl--cms-components-fileUpload-bg: #FFFFFF;\n  --scl--cms-components-fileUpload-border-color: #E5E5E7;\n  --scl--cms-components-fileUpload-border-radius: 10px;\n  --scl--cms-components-fileUpload-drag-bg: #F5F8FF;\n  --scl--cms-components-fileUpload-drag-border-color: var(--primarypalette-blue);\n\n  --scl--cms-components-fileUpload-icon-btn-size: 36px;\n  --scl--cms-components-fileUpload-icon-btn-shadow: 0px 0px 0px 3px #EFF1F3;\n  --scl--cms-components-fileUpload-icon-color: #323539;\n\n  --scl--cms-components-fileUpload-text-color: #323539;\n  --scl--cms-components-fileUpload-link-color: var(--primarypalette-blue);\n  --scl--cms-components-fileUpload-support-color: #858C95;\n}\n\n/* Container */\n.scl--cms-components-fileUpload-container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  gap: 16px;\n  width: 100%;\n  max-width: 429px;\n  min-height: 128px;\n  background: var(--scl--cms-components-fileUpload-bg);\n  border: 1px dashed var(--scl--cms-components-fileUpload-border-color);\n  border-radius: var(--scl--cms-components-fileUpload-border-radius);\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n  position: relative;\n  outline: none;\n}\n\n.scl--cms-components-fileUpload-container:hover {\n  border-color: #C0C0C5;\n  background: #FAFAFA;\n}\n\n.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging {\n  background: var(--scl--cms-components-fileUpload-drag-bg);\n  border-color: var(--scl--cms-components-fileUpload-drag-border-color);\n  box-shadow: 0px 0px 0px 3px rgba(35, 136, 255, 0.15);\n}\n\n.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Hidden native file input */\n.scl--cms-components-fileUpload-input {\n  display: none;\n}\n\n/* Icon Button */\n.scl--cms-components-fileUpload-iconBtn {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  width: var(--scl--cms-components-fileUpload-icon-btn-size);\n  height: var(--scl--cms-components-fileUpload-icon-btn-size);\n  background: var(--scl--cms-components-fileUpload-bg);\n  border: 1px solid var(--scl--cms-components-fileUpload-border-color);\n  box-shadow: var(--scl--cms-components-fileUpload-icon-btn-shadow);\n  border-radius: 128px;\n  flex: none;\n  flex-shrink: 0;\n  transition: box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.scl--cms-components-fileUpload-container:hover .scl--cms-components-fileUpload-iconBtn,\n.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging .scl--cms-components-fileUpload-iconBtn {\n  border-color: var(--primarypalette-blue);\n  box-shadow: 0px 0px 0px 3px rgba(35, 136, 255, 0.15);\n}\n\n/* Upload SVG icon */\n.scl--cms-components-fileUpload-icon {\n  width: 20px;\n  height: 20px;\n  flex: none;\n}\n\n.scl--cms-components-fileUpload-icon path,\n.scl--cms-components-fileUpload-icon line,\n.scl--cms-components-fileUpload-icon polyline {\n  stroke: var(--scl--cms-components-fileUpload-icon-color);\n  stroke-width: 1.67px;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n  transition: stroke 0.2s ease;\n}\n\n.scl--cms-components-fileUpload-container:hover .scl--cms-components-fileUpload-icon path,\n.scl--cms-components-fileUpload-container:hover .scl--cms-components-fileUpload-icon line,\n.scl--cms-components-fileUpload-container:hover .scl--cms-components-fileUpload-icon polyline,\n.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging .scl--cms-components-fileUpload-icon path,\n.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging .scl--cms-components-fileUpload-icon line,\n.scl--cms-components-fileUpload-container.scl--cms-components-fileUpload--dragging .scl--cms-components-fileUpload-icon polyline {\n  stroke: var(--primarypalette-blue);\n}\n\n/* Text block */\n.scl--cms-components-fileUpload-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0px;\n  gap: 6px;\n  width: 100%;\n  flex: none;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n/* Header row */\n.scl--cms-components-fileUpload-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0px;\n  gap: 4px;\n  width: 100%;\n  flex: none;\n  align-self: stretch;\n  flex-wrap: wrap;\n}\n\n.scl--cms-components-fileUpload-headerText {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--scl--cms-components-fileUpload-text-color);\n}\n\n.scl--cms-components-fileUpload-link {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--scl--cms-components-fileUpload-link-color);\n  cursor: pointer;\n  text-decoration: none;\n  transition: opacity 0.15s ease;\n}\n\n.scl--cms-components-fileUpload-link:hover {\n  opacity: 0.8;\n  text-decoration: underline;\n}\n\n/* Support text */\n.scl--cms-components-fileUpload-support {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0px;\n  gap: 4px;\n  width: 100%;\n  flex: none;\n  align-self: stretch;\n  flex-grow: 1;\n}\n\n.scl--cms-components-fileUpload-supportText {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: var(--scl--cms-components-fileUpload-support-color);\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
